module.exports = JBrowseExports["@jbrowse/core/pluggableElementTypes/WidgetType"];